// Must be imported BEFORE any app modules. Initialises Sentry only when a
// non-empty DSN is configured; otherwise the SDK is a no-op.

import * as Sentry from "@sentry/react";
import { sanitizeBreadcrumb, sanitizeEvent } from "./sanitize";

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";
const RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

export const sentryEnabled = Boolean(DSN);

if (sentryEnabled) {
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    release: RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: ENV === "production" ? 0.1 : 1.0,
    sendDefaultPii: false,
    beforeSend(event) {
      return sanitizeEvent(event);
    },
    beforeBreadcrumb(breadcrumb) {
      return sanitizeBreadcrumb(breadcrumb);
    },
  });
  Sentry.setTag("app", "trendrise-frontend");
}

export { Sentry };
